export enum allowedFileTypes {
  image = 1,
  pdf = 2,
  word = 3,
  excel = 4,
  powerpoint = 5,
  text = 6,
  mp4 = 7
  }
